import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { StatusService } from "libs/messages/src/lib/services/status.lib.service";
import { TreatmentStatus } from "libs/treatments/src/lib/models/treatment.model";

@Pipe({ name: "statusToString" })
@Injectable({
	providedIn: 'root'
})
export class TreatmentStatusToStringPipe implements PipeTransform {
	transform(
		value: TreatmentStatus,
		isCustomerFrontend: boolean = false
	): string {
		return StatusService.getStatusStringFromKey(value, isCustomerFrontend);
	}
}
